import { validateEnv } from '@devhacker/shared/utils/validateEnv';

type GaId = 'G-XXXXXXXXXX';
type TopMalId = 'XXXXXXX';

export const NODE_ENV = validateEnv<'production' | 'development'>({
  name: 'NODE_ENV',
  value: import.meta.env.NODE_ENV,
  type: String,
  fallback: 'development',
});

export const isProduction = NODE_ENV === 'production';
export const isDevelopment = NODE_ENV === 'development';

export const PROD_ORIGIN = 'https://lifehacker.ru';

export const PROJECT = validateEnv<'lifehacker'>({
  name: 'PROJECT',
  value: import.meta.env.VITE_PROJECT,
  type: String,
});

export const REDIS_SSR_CACHE = validateEnv({
  name: 'REDIS_SSR_CACHE',
  value: process.env.REDIS_SSR_CACHE,
  type: Boolean,
  fallback: import.meta.server ? undefined : false,
});

export const REDIS_SSR_CACHE_HTTP_TOKEN = validateEnv({
  name: 'REDIS_SSR_CACHE_HTTP_TOKEN',
  value: process.env.REDIS_SSR_CACHE_HTTP_TOKEN,
  type: String,
  fallback: import.meta.server ? undefined : '',
});

export const WORDPRESS_API_URL = validateEnv({
  name: 'WORDPRESS_API_URL',
  value: import.meta.env.VITE_WORDPRESS_API_URL,
  type: String,
});

export const HOME_URL = validateEnv({
  name: 'HOME_URL',
  value: import.meta.env.VITE_HOME_URL,
  type: String,
});

export const TALKER_API_URL = validateEnv({
  name: 'TALKER_API_URL',
  value: import.meta.env.VITE_TALKER_API_URL,
  type: String,
});

export const QUIZ_API_URL = validateEnv({
  name: 'QUIZ_API_URL',
  value: import.meta.env.VITE_QUIZ_API_URL,
  type: String,
});

export const AUTH_API_URL = validateEnv({
  name: 'AUTH_API_URL',
  value: import.meta.env.VITE_AUTH_API_URL,
  type: String,
});

export const PROFILE_API_URL = validateEnv({
  name: 'PROFILE_API_URL',
  value: import.meta.env.VITE_PROFILE_API_URL,
  type: String,
});

export const AUTH_CLIENT_ID = validateEnv({
  name: 'AUTH_CLIENT_ID',
  value: import.meta.env.VITE_AUTH_CLIENT_ID,
  type: String,
  fallback: 'web',
});

export const PUSHER_API_URL = validateEnv({
  name: 'PUSHER_API_URL',
  value: import.meta.env.VITE_PUSHER_API_URL,
  type: String,
});

export const PUSH_API_URL = validateEnv({
  name: 'PUSH_API_URL',
  value: import.meta.env.VITE_PUSH_API_URL,
  type: String,
});

export const SPECIAL_API_URL = validateEnv({
  name: 'SPECIAL_API_URL',
  value: import.meta.env.VITE_SPECIAL_API_URL,
  type: String,
});

export const API_GATEWAY = validateEnv({
  name: 'API_GATEWAY',
  value: import.meta.env.VITE_API_GATEWAY,
  type: String,
});

export const REACTIONS_API_URL = validateEnv({
  name: 'REACTIONS_API_URL',
  value: import.meta.env.VITE_REACTIONS_API_URL,
  type: String,
});

export const SAFARI_PUSH_WEB_SERVICE_URL = validateEnv({
  name: 'SAFARI_PUSH_WEB_SERVICE_URL',
  value: import.meta.env.VITE_SAFARI_PUSH_WEB_SERVICE_URL,
  type: String,
});

export const SAFARI_PUSH_ID = validateEnv<'xxx.xxx.lifehacker.push'>({
  name: 'SAFARI_PUSH_ID',
  value: import.meta.env.VITE_SAFARI_PUSH_ID,
  type: String,
});

export const SAFARI_COOKIE_NAME = validateEnv({
  name: 'SAFARI_COOKIE_NAME',
  value: import.meta.env.VITE_SAFARI_COOKIE_NAME,
  type: String,
});

export const ACCESS_TOKEN_COOKIE_NAME = validateEnv({
  name: 'ACCESS_TOKEN_COOKIE_NAME',
  value: import.meta.env.VITE_ACCESS_TOKEN_COOKIE_NAME,
  type: String,
});

export const GA_ID = validateEnv<GaId>({
  name: 'GA_ID',
  value: import.meta.env.VITE_GA_ID,
  type: String,
});

export const GA_ID_RECIPE = validateEnv<GaId>({
  name: 'GA_ID_RECIPE',
  value: import.meta.env.VITE_GA_ID_RECIPE,
  type: String,
});

export const YA_METRIKA_ID = validateEnv({
  name: 'YA_METRIKA_ID',
  value: import.meta.env.VITE_YA_METRIKA_ID,
  type: Number,
});

export const YA_METRIKA_FOND_ID = validateEnv({
  name: 'YA_METRIKA_FOND_ID',
  value: import.meta.env.VITE_YA_METRIKA_FOND_ID,
  type: Number,
});

export const YA_METRIKA_ID_RECIPE = validateEnv({
  name: 'YA_METRIKA_ID_RECIPE',
  value: import.meta.env.VITE_YA_METRIKA_ID_RECIPE,
  type: Number,
});

export const YA_METRIKA_ID_HEALTH = validateEnv({
  name: 'YA_METRIKA_ID_HEALTH',
  value: import.meta.env.VITE_YA_METRIKA_ID_HEALTH,
  type: Number,
});

export const TOP_MAIL_ID = validateEnv<TopMalId>({
  name: 'TOP_MAIL_ID',
  value: import.meta.env.VITE_TOP_MAIL_ID,
  type: String,
});

export const PUSH_VAPID_PUBLIC_KEY = validateEnv<'xXx-xXXxx_xx_Xxx_Xx_Xx-xxXx'>({
  name: 'PUSH_VAPID_PUBLIC_KEY',
  value: import.meta.env.VITE_PUSH_VAPID_PUBLIC_KEY,
  type: String,
});

export const VIEWS_API_URL = validateEnv({
  name: 'VIEWS_API_URL',
  value: import.meta.env.VITE_VIEWS_API_URL,
  type: String,
});

export const STRIP_WIDGET_PROPERTIES = validateEnv({
  name: 'STRIP_WIDGET_PROPERTIES',
  value: import.meta.env.VITE_STRIP_WIDGET_PROPERTIES,
  type: Boolean,
  fallback: false,
});

export const WEBSOCKET_HOST = validateEnv({
  name: 'WEBSOCKET_HOST',
  value: import.meta.env.VITE_WEBSOCKET_HOST,
  type: String,
  fallback: '',
});

export const SENTRY_SERVER_DNS = validateEnv({
  name: 'SENTRY_SERVER_DNS',
  value: process.env.SENTRY_SERVER_DNS,
  type: String,
  fallback: '',
});

export const SENTRY_CLIENT_DNS = validateEnv({
  name: 'SENTRY_CLIENT_DNS',
  value: import.meta.env.VITE_SENTRY_CLIENT_DNS,
  type: String,
  fallback: '',
});
